import React from 'react';
import update from 'immutability-helper';
import mypageAccess from '../../../../model/mypageAccess';
import Loading from './../misc/Loading';
import MypageAccess from './MypageAccess';
import ValidationError from '../../../../model/error/ValidationError';
import withRouter from '/src/components/misc/withRouter';

const errorToMessage = (error) => {
  console.error(error);
  if (error instanceof ValidationError) {
    return 'Tilgang validerer ikke og kan dermed ikke publiseres. Sjekk at alle påkrevede felter er fylt ut med gyldige verdier og prøv igjen.';
  }

  return 'En ukjent feil inntraff ved behandling av tilgang og handlingen kunne dermed ikke fullføres.';
};

class MypageAccessContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      access: null,
      modified: false,
      working: false,
      error: null
    };

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.fetchAccess(this.props.match.params.brand);
  }

  UNSAFE_componentWillReceiveProps(next) { // eslint-disable-line camelcase
    if (next.match.params.brand) {
      this.setState({
        access: null,
        modified: false,
        working: false,
        error: null
      });

      this.fetchAccess(next.match.params.brand);
    }
  }

  fetchAccess(brand) {
    mypageAccess.getByBrand(brand).then((access) => {
      document.title = `Admin - Min side tilgang - ${access.title}`;
      this.setState({
        access: access
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleSave() {
    this.setState({
      error: null,
      working: true,
      modified: false
    });
    mypageAccess.save(this.state.access).then((access) => {
      this.setState({
        working: false,
        access: access
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handlePublish() {
    this.setState({
      working: true
    });
    mypageAccess.publish(this.state.access.id).then((access) => {
      this.setState({
        working: false,
        access: access
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnpublish() {
    this.setState({
      working: true
    });
    mypageAccess.unpublish(this.state.access.id).then((access) => {
      this.setState({
        working: false,
        access: access
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleChange(props) {
    const state = update(props, {
      modified: {
        $set: true
      }
    });

    this.setState(state);
  }

  render() {
    if (!this.state.access) {
      return <Loading title="Tilgang" text="Laster tilgang" />;
    }

    return <MypageAccess
      access={this.state.access}
      error={this.state.error}
      modified={this.state.modified}
      working={this.state.working}
      onChange={this.handleChange}
      onSave={this.handleSave}
      onPublish={this.handlePublish}
      onUnpublish={this.handleUnpublish}
    />;
  }
}

MypageAccessContainer.defaultProps = {
  brand: null
};

export default withRouter(MypageAccessContainer);
